<template>
    <div v-if="data" >
        <!-- PLOT CTAs-->
        <div 
            class="d-flex px-0 justify-end" 
            cols="5"
        >	
            <!-- Share CTA -->
            <v-btn
                v-if="$route.query.key != '5qRvzgfzOHEfe5dYUwGrJY'"
                id="gtm-plotsidebar-share-plot"
                text
                x-small 
                :ripple="false"
                @click="showShareFavoritePopup = true"
            >
                <v-icon :left="!$vuetify.breakpoint.xs">
                    icon-share
                </v-icon>
                <span 
                    v-if="!$vuetify.breakpoint.xs" 
                    class="habiteo-body-2 text-none" 
                >
                    {{ $t("share.share") }}
                </span>	
            </v-btn>
            <ShareFavoriteDialog
                v-if="showShareFavoritePopup"
                :data="data"
                :showShareFavoritePopup="showShareFavoritePopup"
                @close="showShareFavoritePopup = false"
            />
            <!-- /Share CTA -->

            <!-- Favorite CTA -->
            <v-btn
                v-if="data.widgetType !== '3d-plan' && (!metrics || (metrics && $vuetify.breakpoint.smAndUp)) && !isStandalone"
                id="gtm-plotsidebar-cta-favorite"
                class="pl-4 pr-0 "
                text
                @click.prevent="toggleFavorite()"
            >
                <v-icon 
                    class="icon" 
                    :left="!$vuetify.breakpoint.xs"
                    :color="isFavorite ? 'red' : null"
                >
                    {{ isFavorite ? "icon-heart" : "icon-empty-heart" }}
                </v-icon>
                <span 
                    v-if="!$vuetify.breakpoint.xs" 
                    class="habiteo-body-2 text-none"  
                >
                    {{ $t('favorite.favorite')}}
                </span>
            </v-btn>
            <!-- Favorite CTA -->

            <!-- Metrics CTA -->
            <v-btn
                id="metricsBtn"
                v-if="metrics"
                @click="showMetrics()"
                text
                class="pl-4 pr-0"
            >
                <v-icon :left="!$vuetify.breakpoint.xs">
                    icon-metrics
                </v-icon>
                <span 
                    v-if="!$vuetify.breakpoint.xs" 
                    class="habiteo-body-2 text-none"  
                >
                    {{ $t('utils.metrics')}}
                </span>
                
            </v-btn>
            <v-menu
                v-if="!$vuetify.breakpoint.xs"
                v-model="showMetricsPopup"
                attach="#metricsBtn"
                content-class="mt-8"
                min-width="250px"
            >
                <MetricsDialog
                    :metrics="metrics"
                    :data="data"
                />
            </v-menu>
            <v-dialog 
                v-else
                v-model="showMetricsPopup"
            >
                <v-toolbar height="30" flat>
                        <v-btn
                            icon 
                            color="black"
                            @click="showMetricsPopup = false"
                        >
                            <v-icon black>
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </v-toolbar>  
                <MetricsDialog
                    :metrics="metrics"
                    :data="data"
                />
            </v-dialog>
            <!-- /Metrics CTA -->
            
            <!-- Plot information CTA -->
            <v-btn
                @click="showInformationPopup = true"
                text
                class="pl-4 pr-0 "
                id="plotInformationBtn"
            >
                <v-icon :left="!$vuetify.breakpoint.xs">
                    mdi-information-outline
                </v-icon>
                <span 
                    v-if="!$vuetify.breakpoint.xs"  
                    class="habiteo-body-2 text-none"  
                >
                    {{ $t('utils.information')}}
                </span>	
                
            </v-btn>
            <v-menu
                v-if="!$vuetify.breakpoint.xs"
                v-model="showInformationPopup"
                attach="#plotInformationBtn"
                content-class="plot-detail mt-8"
                min-width="300px"
            >
                <InformationDialog :data="data"/>
            </v-menu>
            <v-dialog
                v-else
                v-model="showInformationPopup"
            >
                <v-toolbar height="30" flat>
                    <v-btn
                        icon 
                        color="black"
                        height="auto"
                        width="auto"
                        @click="showInformationPopup = false"
                    >
                        <v-icon black>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-toolbar>  
                <InformationDialog :data="data"/>
            </v-dialog>
            <!-- Plot information CTA -->
        </div>
        <!-- /PLOT CTAs-->
    </div>
</template>

<script>
    import { EventBus } from "@/event-bus";
    import { mapGetters } from 'vuex';

    import ShareFavoriteDialog from "@/layout/alternative/plot/components/ShareFavoriteDialog";
    import InformationDialog from "@/layout/alternative/plot/components/InformationDialog";
    import MetricsDialog from "@/layout/alternative/plot/components/MetricsDialog";

    export default {
        name: "PlotHeader",
        components: {
            ShareFavoriteDialog,
            InformationDialog,
            MetricsDialog
        },
        props: [	
            "data",
            'isStandalone'
        ],
        data() {
            return {
                showShareFavoritePopup: false,
                showInformationPopup: false,
                showMetricsPopup: false,
                metrics: null,
                plotFavList: [],
                disabledAvailabilities: [
                    2,      // Unavailable
                    4,      // Reserved
                    5       // Sold
                ],
            };
        },
        mounted() {
            this.getMetrics();
            if (this.isLocalstorageAvailable)
                this.plotFavList = localStorage.getItem(this.favoriteKey) ? JSON.parse(localStorage.getItem(this.favoriteKey)) : [];
        },
        computed:{
            ...mapGetters(['isLocalstorageAvailable']),
            programUuid() {
                return this.$props.data.program.id;
            },
            plotId() {
                return this.data ? this.data.plotId : null;
            },
            favoriteKey() {
                return `favorite-${this.programUuid}`;
            },
            favoriteList: {
                get() {
                    return this.plotFavList;
                },
                set(newValue) {
                    localStorage.setItem(this.favoriteKey, JSON.stringify(newValue));
                    this.plotFavList = JSON.parse(localStorage.getItem(this.favoriteKey));
                }
            },
            isFavorite() {
                let status = false;
                if (this.isAvailabilityEnabled())
                    status = this.favoriteList.includes(this.plotId);
                return status;
            },
            
        },
        methods: {
            decodeHTMLfromString(str) {
                let decoder = document.createElement('textarea');
                decoder.innerHTML = str;
                return decoder.value;
            },
            getMetrics() {
                if(this.data.details){
                    const metrics = this.data.details.find(detail => detail.id === "metrics");
                    this.metrics = metrics ? metrics : null;
                }
            },
            showMetrics() {
                this.showMetricsPopup = true;
            },
            
            isAvailabilityEnabled() {
                if(this.data.details){
                    let availability = this.data.details.filter(detail => detail.id === "availability");
                    return availability.length ? !this.disabledAvailabilities.includes(availability[0].type) : false;
                }
                return false;
            },
            toggleFavorite() {
                if (this.plotId) {
                    if (!this.favoriteList.includes(this.plotId)) {
                        var plotList = this.favoriteList ? this.favoriteList : [];
                        plotList.push(this.plotId);
                        this.favoriteList = plotList;
                        this.displayFavoriteBanner();
                    }
                    else {
                        var plotList = this.favoriteList.filter(favPlotId => {
                            return favPlotId !== this.plotId
                        });
                        this.favoriteList = plotList;
                    }
                }
            },
            displayFavoriteBanner() {
                let localStorageKey = 'favorite-banner-' + this.$route.query.id + '-' + this.$route.query.key;
                let nextDisplayDate = this.isLocalstorageAvailable ? localStorage.getItem(localStorageKey) : null;
                let today = new Date().getTime();
                if (!nextDisplayDate || nextDisplayDate <= today) {
                    // 30 days between each time the banner is displayed
                    let lifeCycle = 30 * 24 * 60 * 60 * 1000;
                    let nextDate = new Date(new Date().getTime() + lifeCycle);
                    if (this.isLocalstorageAvailable)
                        localStorage.setItem(localStorageKey, nextDate.getTime());
                    EventBus.$emit('displayFlashMessage', this.$t("flashMessage.favorite"));
                }
            },
        }
    };
</script>

<style lang="scss">
    @import "@/assets/scss/components/_share-favorite.scss";
    @import "@/assets/scss/components/_tags.scss";

    .share {
        margin-right: 50px;
        font-size: 13px;
    }

    .copy {
        cursor: pointer;
    }

    .link {
        text-transform: lowercase;
        display: flex !important;
        font-size: 12px;
    }

    .overflow-ellipsis {
        width: 230px;
        overflow: hidden;
        div {
            &.link {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }

    .v-sheet.v-card.price-section {
        background-color: #f3f3f3;
    }

    .plotDetailsTitle {
        text-decoration: underline;
        padding: 10px 0;
        font-size: 14px;
    }
</style>




// WEBPACK FOOTER //
// src/layout/alternative/plot/PlotHeader.vue